import { CheckMyPermissionDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { NavigationItem } from './navigation-bar.component';

/** The items a menu links to, at any depth. A nested menu is a way to reach its leaves, not a link. */
export function flattenNavigationLeaves(items: NavigationItem[] = []): NavigationItem[] {
  return items.flatMap((item) => (Array.isArray(item.children) ? flattenNavigationLeaves(item.children) : [item]));
}

/** Every url beneath a menu, so the menu reads as selected while any of them is open. */
export function collectNavigationUrls(items: NavigationItem[] = []): string[] {
  return flattenNavigationLeaves(items)
    .map((item) => item.url)
    .filter((it): it is string => !!it);
}

/**
 * Whether a menu should show, judged on its leaves:
 * a) if every leaf requires permissions, show the menu when at least one of them passes
 * b) if any leaf requires none, the menu always has something to offer
 */
export function makeNavigationLeafPermissions(items: NavigationItem[] = []): {
  permissions?: CheckMyPermissionDto[];
  onlyRequireSomePermissions: boolean;
} {
  const leaves = flattenNavigationLeaves(items);
  const isAllLeavesRequirePermission = !leaves.some((leaf) => !leaf.permissions || !leaf.permissions.length);

  return {
    permissions: isAllLeavesRequirePermission ? leaves.flatMap((leaf) => leaf.permissions || []) : undefined,
    onlyRequireSomePermissions: isAllLeavesRequirePermission
  };
}
